<template>
    <div class="fleet-view">
        <div class="bg-white p-3 mt-3 activity-type-create col-12">
            <div class="d-flex title-bar-block mb-2">
                <div class="icon-block me-4">
                    <button v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                        <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="text">
                    <span class="me-2">{{ title }}</span>
                </div>
            </div>
            <b-form class="form-sample" @submit.stop.prevent="CreateOrUpdate">
                <b-row>
                    <b-col cols="12">
                        <label class="mb-3"><strong>{{ $nameLabel() }}<span class="red">*</span> </strong></label>
                        <b-form-input type="text" id="input-name" v-custom-validation="$textRequired()" v-model="model.name"
                            required :placeholder="$translate('enter_name')" trim></b-form-input>
                    </b-col>
                    <b-col cols="12" class="mt-3 dd" v-if="!isNew">
                        <label class="mb-3"><strong>{{ $translate('driver') }}<span class="red">*</span></strong></label>
                        <b-form-select class="form-control" v-custom-validation="$selectRequired()" id="input-driver"
                            required name="input-driver" v-model="model.driver" value-field="id" text-field="name" :options="drivers.map(x => {
                                x.name = `${x.first_name} ${x.last_name}`
                                return x
                            })
                                ">
                            <template #first>
                                <b-form-select-option :value="null">{{ $translate('select_driver') }}</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('registration') }}<span class="red">*</span>
                            </strong></label>
                        <b-form-input type="text" id="input-registration" v-custom-validation="$textRequired()"
                            v-model="model.registration" required :placeholder="$translate('enter_registration')"
                            trim></b-form-input>
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('model') }}<span class="red">*</span></strong> </label>
                        <b-form-input type="text" id="input-model" v-custom-validation="$textRequired()"
                            v-model="model.model" required :placeholder="$translate('enter_model')" trim></b-form-input>
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('description') }}</strong>
                        </label>
                        <b-form-textarea id="input-description" v-model="model.description"
                            :placeholder="$translate('enter_description')" rows="3"></b-form-textarea>
                    </b-col>
                    <b-col cols="12" class="my-3">
                        <label class="mb-3"><strong>{{ $translate('color') }}</strong> </label>
                        <b-form-input type="color" id="input-color" v-model="model.color"></b-form-input>
                    </b-col>

                    <b-col cols="12" class="mt-3 d-flex gap-2 justify-content-center">
                        <b-button variant="info" v-if="hasPermissionUpdate" type="submit" class="btn-fw"
                            :disabled="submitting ? true : false">{{ submitLabel }}
                        </b-button>

                        <b-button v-if="hasPermissionDelete && !isNew" @click="deleteVehicle()" class="float-right"
                            variant="delete-button" size="fw">
                            <b-spinner v-show="generalDeleting" label="Spinning"></b-spinner>
                            {{ $deleteLabel() }}
                        </b-button>

                        <b-button variant="info" :disabled="submitting" class="btn-fw" @click="cancel()">
                            {{ $cancelLabel() }}
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import utilityMixins from '@/mixins/utilityMixins'

export default {
    name: 'fleet-viewVehicle',
    mixins: [popupMixins, permissionsMixins, utilityMixins],
    data() {
        return {
            model: {
                id: 0,
                name: '',
                location: '',
                lat: '',
                lon: '',
                driver: 0,
                warehouse: 0,
            },

            updating: false,

            submitting: false,
        }
    },
    computed: {
        componentName() { return this.$translate('fleet') },
        submitLabel() {
            if (this.submitting && this.model.id) {
                return this.$translate('updating')
            } else if (this.submitting) {
                return this.$translate('creating')
            } else if (this.model.id) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },
        title() {
            return this.isNew ? this.$translate('create_vehicle') : this.$translate('vehicle')
        },
        vehicle() {
            const vehicle = { ...this.$store.state.fleet.vehicle }
            vehicle.driver = vehicle.driver && vehicle.driver.user_id
            console.log('vehcile', vehicle)
            return vehicle
        },
        drivers() {
            return this.$store.state.fleet.drivers
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        isNew() {
            if (this.model.id == 0 || this.model.id == null) {
                return true
            } else {
                return false
            }
        },
    },
    watch: {
        vehicle: function (val) {
            this.model = val
        },
    },
    methods: {
        cancel() {
            this.$router.push('/ams/fleet')
        },

        CreateOrUpdate() {
            this.submitting = true
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.$store
                        .dispatch(
                            this.model.id !== 0 ? 'fleet/update' : 'fleet/create',
                            this.model
                        )
                        .then(() => {
                            if (this.model.id !== 0) {
                                this.$router.push({ name: 'fleet' })
                                this.$nextTick(() => {
                                    this.genericToast(
                                        this.componentName,
                                        this.$translate('updated'),
                                        'success',
                                        `${this.componentName} ${this.$translate('update_alert')}`
                                    )
                                })

                            } else {
                                this.$router.push({ name: 'fleet' })
                                this.$nextTick(() => {
                                    this.genericToast(
                                        this.componentName,
                                        this.$translate('created'),
                                        'success',
                                        `${this.componentName} ${this.$translate('create_alert')}`
                                    )
                                })
                            }
                        })
                        .catch(error => {
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                            console.log(error)
                        })
                        .finally(() => {
                            this.submitting = false
                        })
                } else {
                    this.submitting = false
                }
            })
        },
        async deleteVehicle() {
            // Initializing key variables
            const model = { ...this.model }
            const routes = {
                baseRoute: '/ams/fleet',
                deleteRoute: 'fleet/delete',
            }
            const notificationFields = {
                type: this.$translate('vehicle'),
                errorMsg: this.$translate('unable_fleet_alert'),
            }

            await this.deleteItem(notificationFields, model, routes)
        },
    },
    mounted() {
        if (this.$route.params.id !== 0) {
            this.$store.dispatch('fleet/fetchById', this.$route.params.id)
        }
        this.$store.dispatch('fleet/fetchDrivers')
    },
}
</script>
<style></style>
